<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-info">
          <p><strong>주식회사 아스톡</strong></p>
          <p>대표이사: 차호규 | 사업자등록번호: 128-86-47665</p>
          <p>주소: 경기도 고양시 덕양구 삼원로63 (아크비즈)</p>
          <p>대표전화: 1533-0231 | 이메일: pera65@naver.com</p>
        </div>
        <div class="copyright">
          <p>&copy; 2010 ASTOC Inc. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer { background: #222; color: #999; padding: 4rem 0; font-size: 14px; }
.footer-content { display: flex; justify-content: space-between; align-items: flex-end; }
.footer-info p { margin-bottom: 0.5rem; }
.copyright { text-align: right; }
</style>